module.exports = __webpack_public_path__ + "static/media/IMG_3528.c8597366.PNG";